import React, { FC, useState } from 'react';
import { useGetProgramMasterData } from 'src/api/mutations/useGetProgramMasterData';
import './IntensityVibeStep.scss';
import { ReactComponent as High_intensityIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/high_intensity.svg';
import { ReactComponent as Low_intensityIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/low_intensity.svg';
import { ReactComponent as BalancedIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/balanced.svg';

interface IntensityVibeStepProps {
  onBack?: () => void;
  onNext?: () => void;
  clientName?: string;
  value?: string;
  onChange?: (val: string) => void;
}

const iconMapping: Record<string, React.ReactNode> = {
  low_intensity: <Low_intensityIcon />,
  balanced: <BalancedIcon />,
  high_intensity: <High_intensityIcon />,
};

// What’s the intensity vibe for this program?
// Pick the baseline stimulus you want your client to experience.
export const IntensityVibeStep: FC<IntensityVibeStepProps> = ({
  onNext,
  clientName,
  value,
  onChange,
}) => {
  const [localLevel, setLocalLevel] = useState<string>('');
  const selectedLevel = value !== undefined ? value : localLevel;

  const { data: programMasterData, isLoading, isError } = useGetProgramMasterData();
  const programIntensity = programMasterData?.programIntensity;

  const nameDisplay = clientName ? `${clientName}'s` : 'their';
  // Use replace similar to EnergyLevel if there's any placeholder, though likely not for this step
  const displayTitle = programIntensity?.title.replace('{{clientName}}', nameDisplay);

  // Use the API options and ensure they are sorted by order
  const options = [...(programIntensity?.options || [])].sort(
    (a, b) => (a.order || 0) - (b.order || 0),
  );

  const getIcon = (id: string) => iconMapping[id] || null;

  if (isLoading) {
    return <div className="intensity-vibe-step">{'Loading options...'}</div>;
  }

  if (isError || !programIntensity) {
    return <div className="intensity-vibe-step">{'Error loading options.'}</div>;
  }

  return (
    <div className="intensity-vibe-step">
      <h2 className="step-title">{displayTitle}</h2>
      <p className="step-subtitle">{programIntensity?.subtitle}</p>

      <div className="intensity-cards">
        {options.map((level) => (
          <button
            key={level.id}
            className={`intensity-card ${selectedLevel === level.slug ? 'selected' : ''}`}
            onClick={() => {
              if (onChange) onChange(level.slug);
              setLocalLevel(level.slug);
              if (onNext) onNext();
            }}
          >
            <div className="icon-wrapper">{getIcon(level.id)}</div>
            <span className="level-label">{level.title}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
